/* @flow */

import configureStore from './configure-store';
import { type PreactAppStore } from './types';

const getStore = (): PreactAppStore => {
    if (!global.REDUX_STORE) {
        global.REDUX_STORE = configureStore();
    }
    return global.REDUX_STORE;
};

export default getStore;
